import React, {Component} from 'react';
const { connect } = require('react-redux');
import {Helmet} from 'react-helmet';

import HeaderBrief from '../../components/profile/HeaderBrief';
import WallMaterialList from 'components/list/WallMaterialList';
import Loading from 'components/Loading';
import NotFound from 'containers/NotFound';

import {t, dt} from 'l10n'

import {getProfileWallPosts} from 'reducers/profileWallPosts';

import 'sass/profile/postwall.scss';

class ProfileWallPosts extends Component {
    static fetchData({dispatch, match}) {
        let {nick} = match.params;

        return dispatch(getProfileWallPosts(nick));
    }

    componentDidMount() {
        let {dispatch, match, user} = this.props;

        if (!user || match.params.nick !== user.nick) {
            this.constructor.fetchData({dispatch, match});
        }
    }

    render() {
        let {match, user, online, wallMaterials} = this.props,
            {list, totalCount} = wallMaterials;

        if (!user) {
            return <Loading centered/>;
        }

        if (user._notFound) {
            return <NotFound {...this.props}/>
        }

        return (
            <div id="wrapper">
                <HeaderBrief user={user} online={online} match={match}/>
                {user &&
                <Helmet>
                    <title>{dt('meta', 'Wall posts of %1', user.nick)}</title>
                    <meta name="description" content={dt('meta', 'The wall of BobTV, photos and videos posted by %1', user.nick, user.region || user.country)}/>
                </Helmet>
                }
                <aside className="my-postwall">
                    <div className="content">
                        <div className="heading">
                            <h2>{t('Posts on the Wall')} <em>{totalCount}</em></h2>
                        </div>

                        <WallMaterialList wallMaterials={list} responsiveGrid showDate showStats altThumbnail/>

                    </div>
                </aside>
            </div>
        )
    }
}

export default connect(
    state => ({
        user: state.profileWallPosts.user,
        online: state.profileWallPosts.online,
        wallMaterials: state.profileWallPosts.wallMaterials,
        currentUser: state.currentUser
    }),
    null
)(ProfileWallPosts)


// WEBPACK FOOTER //
// ./src/containers/profile/ProfileWallPosts.js